import ErrorStatus from '$shared/constants/ErrorStatus';
import Label from '$shared/constants/Label';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { formatString } from '$shared/helpers/utils';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';

class OrganizationError {
  public getSettings(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        formatString(UIErrorMessage.FailedToGetInfo, Label.OrgSettings),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        formatString(UIErrorMessage.PermissionMissingToGetInfo, Label.OrgSettings),
        true
      )
    };
  }

  public getSsoAdminLink(): ErrorStatusMapping {
    return {
      [ErrorStatus.UnAuthourized]: ErrorMessage.create(UIErrorMessage.PermissionMissingToUpdateInfo),
      [ErrorStatus.Forbidden]: ErrorMessage.create(UIErrorMessage.ActionForbidden)
    };
  }

  public modifyOAuthClientSecrets(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        formatString(UIErrorMessage.FailedToUpdateInfo, Label.OrgSettings),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        formatString(UIErrorMessage.PermissionMissingToUpdateInfo, Label.OrgSettings),
        true
      )
    };
  }

  public getAIOrganization(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        'Failed to get AI organization settings',
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        'Organization not authorized for AI features',
        false
      )
    };
  }
}

export const organizationError = new OrganizationError();
